import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=43fc868d&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"
import style0 from "./Videos.vue?vue&type=style&index=0&id=43fc868d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fc868d",
  null
  
)

export default component.exports